import React from 'react'

import './BottomSheet.scss'

interface BottomSheetProps {
    children: JSX.Element[] | JSX.Element,
    show: boolean,
    close?: () => void
}

const BottomSheet: React.FC<BottomSheetProps> = ({children, show, close}: BottomSheetProps) => {

    return (
        <>
            <div className={`bottomSheet ${show ? 'active' : ''}`} onClick={close}>
            </div>
            <div className={`bottomSheetBody ${show ? 'active' : ''}`}>
                {children}
            </div>
        </>
    )
}

export default BottomSheet;
